require('./accueil-interface-1.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class AccueilInterface1Component {
  constructor() {
    this.controller = AccueilInterface1Controller;
    this.template = require('./accueil-interface-1.html');
  }
}

// @ngInject
class AccueilInterface1Controller {

  constructor($scope, $ngRedux) {
    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ACCUEIL_INTERFACE_1));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.accueilInterface1 ? state.demande.data.accueilInterface1.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.prerequis = {antenne: false , orage: false, logement: false};
    this.disableNext = true;
  }

  onPrerequisChange(prerequis) {
    this.disableNext = prerequis.antenne && prerequis.logement && prerequis.orage === true ? false : true ;
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface1(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface1(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/accueil-interface-1/accueil-interface-1.component.js